<template>
  <Layout>
    <div class="section  content is-size-7 has-text-white">
      <p class="is-size-5 has-text-primary">Zrušení</p>
      <p>
        Poplatky za služby se automaticky obnoví, dokud zákazník nezruší odesláním STOP AAA do roku 90303. 
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Deactivation',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/FI/Deactivation.vue